import pkg from '../package.json'

export const CLIENT_NAME = pkg.name
export const CLIENT_VERSION = pkg.version
